import { Playbook } from '@driftt/api-types'

import { EMAIL_FUNNEL_METRIC_KEYS } from 'constants/playbooks'

import {
  IFunnelMetric,
  IPlaybooksMetricsResponse,
  PlaybooksById,
} from './types'

export const parseFetchPlaybooksResponse = (
  playbooks: Playbook[]
): PlaybooksById =>
  playbooks.reduce((playbooksById, playbook: Playbook) => {
    playbooksById[playbook.id] = playbook
    return playbooksById
  }, {})

export const parseFetchPlaybookMetricsResponse = (data: any[]) =>
  data.reduce((metricsById, metricItem: IPlaybooksMetricsResponse) => {
    if (metricItem.playbookId) {
      return {
        ...metricsById,
        [metricItem.playbookId!]: {
          playbookId: metricItem.playbookId,
          metrics: metricItem.metrics.reduce(
            (metrics: { [key: string]: number }, item: IFunnelMetric) => {
              if (EMAIL_FUNNEL_METRIC_KEYS.includes(item.key)) {
                return {
                  ...metrics,
                  [item.key]: item.metric.value,
                }
              }
              return metrics
            },
            {}
          ),
        },
      }
    }
    return metricsById
  }, {})
